import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "zone-layout" }

import { useRouter } from 'vue-router'
import CZoneTournamentItem from '@/components/CZoneTournamentItem.vue'
import { TOURNAMENT_TYPE, TournamentTypeToName } from '@/model/TournamentType'
import { ZoneSelectionUi } from '@/model/ZoneSelection'
import { track } from '@/lib/track'


export default /*#__PURE__*/_defineComponent({
  __name: 'MZoneSelection',
  props: {
    zoneTeaserUi: {}
  },
  emits: ['close'],
  setup(__props: any, { emit: __emit }) {

/**
 * Renders only the teasers for the zone ZoneOverviewView.
 */

const emit = __emit
const router = useRouter()

function onZoneSelect(tournamentType: TOURNAMENT_TYPE) {
  router.push(`/tournaments/${TournamentTypeToName[tournamentType]}`)
  track({
    id: 'zoneSelection',
    elem: 'zone-clicked',
    data: tournamentType,
  })
}

return (_ctx: any,_cache: any) => {
  const _component_t_container = _resolveComponent("t-container")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["zone-selection t-text", _ctx.zoneTeaserUi.gametype])
  }, [
    _createVNode(_component_t_container, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(CZoneTournamentItem, {
            onOnGoToZone: onZoneSelect,
            class: "zone-item",
            zoneSelectionUi: _ctx.zoneTeaserUi,
            language: _ctx.$i18n.locale
          }, null, 8, ["zoneSelectionUi", "language"])
        ])
      ]),
      _: 1
    })
  ], 2))
}
}

})